import React from "react";
import { observer } from "mobx-react";
import { VatStatusCreateStore } from "../../store";
import { VatStatusCreateForm } from "./VatStatusCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type VatStatusCreateProps = {
  vatStatusCreateStore: VatStatusCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const VatStatusCreate: React.FC<VatStatusCreateProps> = observer(
  ({ vatStatusCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={vatStatusCreateStore.isSaving} />
        <VatStatusCreateForm
          vatStatusCreateStore={vatStatusCreateStore}
          name_esError={vatStatusCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            vatStatusCreateStore.setName_esValue(value);
          }}
          name_es={vatStatusCreateStore.entityValues.name_es}
          name_enError={vatStatusCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            vatStatusCreateStore.setName_enValue(value);
          }}
          name_en={vatStatusCreateStore.entityValues.name_en}
          name_ptError={vatStatusCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            vatStatusCreateStore.setName_ptValue(value);
          }}
          name_pt={vatStatusCreateStore.entityValues.name_pt}
          description_esError={
            vatStatusCreateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            vatStatusCreateStore.setDescription_esValue(value);
          }}
          description_es={vatStatusCreateStore.entityValues.description_es}
          description_enError={
            vatStatusCreateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            vatStatusCreateStore.setDescription_enValue(value);
          }}
          description_en={vatStatusCreateStore.entityValues.description_en}
          description_ptError={
            vatStatusCreateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            vatStatusCreateStore.setDescription_ptValue(value);
          }}
          description_pt={vatStatusCreateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={vatStatusCreateStore.isProcessing}
          onSave={() => vatStatusCreateStore.saveNewVatStatus()}
          onCancel={() => vatStatusCreateStore.cancelNewVatStatus()}
        />
        <ErrorDialog
          open={vatStatusCreateStore.errorDialogOpened}
          title={vatStatusCreateStore.errorTitle}
          description={vatStatusCreateStore.errorDescription}
          onClose={() => vatStatusCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
